import AppForm from '../app-components/Form/AppForm';

Vue.component('dynamic-field-section-form', {
    mixins: [AppForm],

    props: {
        availableDynamicFields: {
            type: Array,
            required: false,
            default: function() {
                return [];
            },
        },
        initialLayoutItems: {
            type: Array,
            required: false,
            default: function() {
                return [];
            },
        },
    },

    data: function() {
        return {
            form: {
                name: {
                    sk: '',
                    cs: '',
                    en: '',
                },
                icon: '',
                scope: 1,
                order: 0,
                company_id: null,
                layout_items: [],
            }
        }
    },

    created: function() {
        if (this.data && this.data.name_translations) {
            this.form.name = Object.assign({ sk: '', cs: '', en: '' }, this.data.name_translations);
        }

        if (Array.isArray(this.initialLayoutItems)) {
            this.form.layout_items = this.initialLayoutItems.map(function(item, index) {
                return {
                    item_type: item.item_type || 'system_field',
                    system_field: item.system_field || null,
                    dynamic_field_id: item.dynamic_field_id || null,
                    order: item.order != null ? item.order : (index + 1),
                    width: item.width != null ? item.width : 6,
                };
            });
        }
    },

    computed: {
        filteredDynamicFields: function() {
            var selectedCompanyId = parseInt(this.form.company_id);
            var selectedScope = parseInt(this.form.scope);

            return this.availableDynamicFields.filter(function(field) {
                return parseInt(field.company_id) === selectedCompanyId && parseInt(field.scope) === selectedScope;
            });
        }
    },

    methods: {
        goBack()
        {
            window.location.href = '/dynamic-field-sections';
        },
    }
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/dynamic-field-sections/Form.js